import {Component, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FieldConfig} from '../field.interface';
import {AppService} from '@app/app.service';

@Component({
    selector: 'app-text',
    templateUrl: './text.component.html',
    styleUrls: ['./text.scss'],
})
export class TextComponent implements OnInit {
    field: FieldConfig;
    group: FormGroup;

    constructor(public appService: AppService) {
    }

    ngOnInit() {
        if (this.field.disabled) {
            setTimeout(() => {
                this.group.get(this.field.name).disable({onlySelf: true, emitEvent: false});
            });
        }
    }

    /**
     * Установка запрета изменения поля
     * @param disabled значение флага
     */
    setDisabled(disabled) {
        this.field.disabled = disabled;
        if (this.field.disabled) {
            this.group.get(this.field.name).disable({onlySelf: true, emitEvent: false});
        } else {
            this.group.get(this.field.name).enable({onlySelf: true, emitEvent: false});
        }
    }
}
